import { BRANDS } from "../lib/site";

export const BrandMarquee = () => {
  const doubled = [...BRANDS, ...BRANDS];
  return (
    <section
      data-testid="brand-marquee-section"
      className="bg-[#101218] border-y border-white/5 py-10 overflow-hidden"
      aria-label="علامات السيارات المدعومة"
    >
      <p className="text-center font-mono text-xs tracking-[0.3em] text-slate-500 uppercase mb-7 px-4">
        نتعامل مع حساسات أشهر علامات السيارات في السعودية
      </p>
      <div dir="ltr" className="relative">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#101218] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#101218] to-transparent z-10 pointer-events-none" />
        <div className="marquee-track gap-4 px-4">
          {doubled.map((b, i) => (
            <span
              key={`${b}-${i}`}
              dir="rtl"
              data-testid={i < BRANDS.length ? `brand-pill-${i}` : undefined}
              className="whitespace-nowrap text-sm font-display font-semibold text-slate-300 border border-white/10 bg-white/[0.03] rounded-full px-6 py-2.5 hover:border-red-500/40 hover:text-white transition-colors"
            >
              {b}
            </span>
          ))}
        </div>
      </div>
      <p className="text-center text-xs text-slate-500 mt-7 px-4 max-w-2xl mx-auto leading-relaxed">
        التوافق يعتمد على الموديل وسنة الصنع ونوع نظام مراقبة الضغط — أرسل
        بيانات سيارتك عبر واتساب لنحدد لك الحساس المناسب.
      </p>
    </section>
  );
};
